__turbopack_context__.v({
  "actionBtn": "SidebarPlan-module__dykIeq__actionBtn",
  "amount": "SidebarPlan-module__dykIeq__amount",
  "amountRow": "SidebarPlan-module__dykIeq__amountRow",
  "card": "SidebarPlan-module__dykIeq__card",
  "collapsed": "SidebarPlan-module__dykIeq__collapsed",
  "fill": "SidebarPlan-module__dykIeq__fill",
  "header": "SidebarPlan-module__dykIeq__header",
  "icon": "SidebarPlan-module__dykIeq__icon",
  "left": "SidebarPlan-module__dykIeq__left",
  "meter": "SidebarPlan-module__dykIeq__meter",
  "meterHead": "SidebarPlan-module__dykIeq__meterHead",
  "meterLabel": "SidebarPlan-module__dykIeq__meterLabel",
  "meterValue": "SidebarPlan-module__dykIeq__meterValue",
  "meters": "SidebarPlan-module__dykIeq__meters",
  "title": "SidebarPlan-module__dykIeq__title",
  "track": "SidebarPlan-module__dykIeq__track",
});
